import React from 'react';
import SchnellanfragenConfig from '../../SchnellanfragenConfig';

interface Props {
  authToken: string;
}

const SchnellanfragenSection: React.FC<Props> = ({ authToken }) => (
  <div>
    <h3 style={{ marginTop: 0 }}>Schnellanfragen</h3>
    <p style={{ color: 'var(--ink-2)', marginBottom: 16, fontSize: 14 }}>
      Definiere Chips die unter dem Chat angezeigt werden. Chips sind rollenbasiert —
      jeder Benutzer sieht nur die Chips seiner Rolle.
    </p>
    <SchnellanfragenConfig authToken={authToken} />
  </div>
);

export default SchnellanfragenSection;
